export default function PHP_is_uploaded_file() {
  return (
    <div>
      <h1>PHP_is_uploaded_file</h1>
    </div>
  );
}
